// extracted by mini-css-extract-plugin
export default {"root":"EditModal_root__ZzHTi","container":"EditModal_container__LX+-z"};